import gql from 'graphql-tag';

export const MUTATION_LEAVE_FEEDBACK = gql`
  mutation mutationLeaveFeedback($input: FeedbackInput!) {
    result: leaveFeedback(input: $input)
  }
`;
